import { ApiEndpointUrl } from "../../common";
export const categoryPoint = {
    list: ApiEndpointUrl + "categories",

    sublist: ApiEndpointUrl + "descendant-categories",

    menucats: ApiEndpointUrl + "parentssubcat?cats=10,11",
};
